import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import SettingService from '../../services/SettingService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
// import UserTransportDetailsResponse from './UserTransportDetailsResponse';
import {TabPanel, TabView} from 'primereact/tabview';
import {ProgressBar} from 'primereact/progressbar';
import {Message} from 'primereact/message';
import CompanyService from '../../services/CompanyService';
import ImageComponent from '../../components/inputs/ImageComponent';
import StringUtils from '../../utils/StringUtils';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import LocationsComponentV2 from '../../components/locations/LocationComponentV2';
import CompanyAgreementService from '../../services/CompanyAgreementService';
import CompanyLocationImportService from '../../services/CompanyLocationImportService';
import moment from 'moment';
import YesNoDialog from '../../components/YesNoDialog';
import {getGroupPointsAlgorithmOptions, GROUP_POINTS_ALGORITHM} from '../../utils/GroupPointsAlgorithmUtils';

class CompanyContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new CompanyService());
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            tabIndex: 0,
            locale: sessionStorage.getItem('i18nextLng'),
            globalLocale: props.locale,
            imgMaxSizeParameter: undefined,
            fileSizeToTranslation: undefined,
            companyLocationsLoading: true,
            supportedLocales: [],
            locationImportProgress: undefined,
            locationImportErrors: [],
            element: {
                translations: [],
            },
        };
        this.settingService = new SettingService();
        this.editorRef = React.createRef();
        this.locationImportInputRef = React.createRef();
        this.companyAgreementService = new CompanyAgreementService();
        this.companyLocationImportService = new CompanyLocationImportService();
        this.locationImportPollingInterval = null;
    }
    changeTab = (e) => {
        sessionStorage.setItem('tab-company-index', e.index);
        this.setState({
            tabIndex: e.index,
        });
    };
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateElement(data) {
        this.setState(
            {
                element: {
                    ...data,
                    groupPointsAlgorithm: data.groupPointsAlgorithm || GROUP_POINTS_ALGORITHM.LOGARITHM,
                },
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        const {locale} = this.state;
        this.service
            .get()
            .then((data) => {
                this.setState({loading: false, locale}, () => this.updateElement(data));
            })
            .catch((err) => {
                this.handleGetDetailsError(err);
            });
    }
    prepareElementBeforeRequest(element) {
        element.imageChanged = false;
        if (StringUtils.isBlank(element.logoUuid)) {
            element.imageChanged = true;
        }
        if (StringUtils.isBlank(element.logoDarkUuid)) {
            element.imageDarkChanged = true;
        }
        return element;
    }
    createOrUpdate() {
        const {element} = this.state;
        const {detailUrl} = this.props;
        const request = this.prepareElementBeforeRequest(element);

        this.scrollToTop();
        this.service
            .update(request)
            .then(() => {
                this.persistMessage('success', '', 'Zaktualizowano firmę');
                // window.location.href = AppPrefixUtils.locationHrefUrl(detailUrl);
                this.props.history.push(AppPrefixUtils.locationHrefUrl(detailUrl));
                this.setElement();
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
            });
    }
    initBeforeSetElement() {
        if (!StringUtils.isBlank(sessionStorage.getItem('tab-company-index'))) {
            this.setState({
                tabIndex: parseInt(sessionStorage.getItem('tab-company-index')),
            });
        }
        this.settingService
            .getImageSize()
            .then((imgMaxSizeParameter) => {
                this.setState({
                    imgMaxSizeParameter,
                    fileSizeToTranslation: imgMaxSizeParameter * 0.001 + t('global.maxFileSizeUnit'),
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });

        // load company agreements status
        this.companyAgreementService
            .getStatus()
            .then((status) => {
                // Zapisz status w sessionStorage, żeby banner mógł go użyć
                sessionStorage.setItem('company-agreement-status', JSON.stringify(status));
                this.setState({companyAgreementStatus: status});
            })
            .catch((err) => {
                console.log(err);
            });
    }

    prepareHeaderItems() {
        return [
            {
                customRenderFunction: this.renderlocaleuages,
                rendered: true,
                className: 'float-left',
            },
        ];
    }

    
    initAfterSetElement() {
        this.unblockUi()
        this.setState(
            {
                companyLocationsLoading: false,
            }
        );
    }
    prepareFooterItems() {
        const {detailUrl, editUrl} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const hideEditOnAgreementsTab = this.state.tabIndex === 3;
        return [
            {
                label: t('global.cancel'),
                onClick: () => {
                    this.setElement();
                    // window.location.href = AppPrefixUtils.locationHrefUrl(detailUrl);
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(detailUrl));
                },
                className: 'gray float-right',
                rendered: viewMode === 'EDIT',
            },
            {
                label: t('global.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl));
                },
                iconName: 'mdi-pencil',
                className: 'float-right edit-btn',
                rendered: this.props.viewMode === 'VIEW' && !hideEditOnAgreementsTab,
            },
            {
                label: t('global.save'),
                className: 'float-right save-btn',
                onClick: (e) => {
                    this.handleFormSubmit(e);
                },
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
        ];
    }

    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    changeLocalLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
    }

    renderlocaleuages = () => {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                insideTable
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    };

    renderAgreementsStatus() {
        const s = this.state.companyAgreementStatus;
        if (!s) return null;
        return (
            <div className='row'>
                <div className='col-12 mb-3'>
                    <div className={`alert ${s.allAgreementsAccepted ? 'alert-success' : 'alert-warning'}`} role='alert'>
                        {s.allAgreementsAccepted
                            ? 'Wszystkie wymagane zgody zostały zaakceptowane.'
                            : 'Nie wszystkie wymagane zgody zostały zaakceptowane.'}
                    </div>
                </div>
                <div className='col-12'>
                    <div className='card mb-4' style={{border: '1px solid #E6E8EB'}}> 
                        <div className='card-header'>Akceptacje</div>
                        <div className='card-body p-0'>
                            <table className='table table-sm mb-0'>
                                <thead>
                                    <tr>
                                        <th>Nazwa zgody</th>
                                        <th>Data akceptacji</th>
                                        <th>Użytkownik</th>
                                        <th>Link</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {s.acceptedAgreements && s.acceptedAgreements.length > 0 ? (
                                        s.acceptedAgreements.map((a, idx) => (
                                            <tr key={`acc-${idx}`}>
                                                <td>{a.agreementName}</td>
                                                <td>{a.acceptedDate ? moment(a.acceptedDate).format('YYYY-MM-DD HH:mm') : '-'}</td>
                                                <td>{a.acceptedByUserName}</td>
                                                <td>
                                                    {a.agreementUrl ? (
                                                        <a href={a.agreementUrl} target='_blank' rel='noreferrer'>
                                                            Otwórz
                                                        </a>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan='4' className='text-muted text-center'>Brak zaakceptowanych zgód</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {s.notAcceptedAgreementIds && s.notAcceptedAgreementIds.length > 0 ? (
                    <div className='col-12 mt-3'>
                        <div className='card' style={{border: '1px solid #E6E8EB'}}> 
                            <div className='card-header'>Brakujące zgody</div>
                            <div className='card-body p-0'>
                                <table className='table table-sm mb-0'>
                                    <thead>
                                        <tr>
                                            <th>ID zgody</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {s.notAcceptedAgreementIds.map((id) => (
                                            <tr key={`miss-${id}`}>
                                                <td>{id}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                ) : s.notAcceptedAgreements && s.notAcceptedAgreements.length > 0 ? (
                    <div className='col-12 mt-3'>
                        <div className='card' style={{border: '1px solid #E6E8EB'}}> 
                            <div className='card-header'>Brakujące zgody</div>
                            <div className='card-body p-0'>
                                <table className='table table-sm mb-0'>
                                    <thead>
                                        <tr>
                                            <th>Nazwa zgody</th>
                                          
                                            <th>Link</th>
                                            <th style={{width: '1%'}}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {s.notAcceptedAgreements.map((n) => (
                                            <tr key={`miss-${n.agreementId}`}>
                                                <td>{n.agreementName}</td>
                                                
                                                <td>
                                                    {n.agreementUrl ? (
                                                        <a href={n.agreementUrl} target='_blank' rel='noreferrer'>
                                                            Otwórz
                                                        </a>
                                                    ) : (
                                                        '-'
                                                    )}
                                                </td>
                                                <td className='text-right pr-3'>
                                                    <button
                                                        type='button'
                                                        className='p-button p-component p-button-text-only'
                                                        onClick={() => this.setState({confirmAccept: n})}
                                                    >
                                                        <span className='p-button-text p-c'>Akceptuj</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                ) : null}
                {this.state.confirmAccept ? (
                    <YesNoDialog
                        header={'Potwierdzenie'}
                        name='confirmAccept'
                        visible={!!this.state.confirmAccept}
                        onHide={() => this.setState({confirmAccept: undefined})}
                        onChange={(type, x, target) => {
                            if (target.value) {
                                const id = this.state.confirmAccept?.agreementId;
                                this.setState({confirmAccept: undefined}, () => this.handleAcceptAgreement(id));
                            } else {
                                this.setState({confirmAccept: undefined});
                            }
                        }}
                    >
                        <span>
                            Czy na pewno chcesz zaakceptować zgodę: <b>{this.state.confirmAccept?.agreementTitle || this.state.confirmAccept?.agreementName}</b>?
                        </span>
                    </YesNoDialog>
                ) : null}
            </div>
        );
    }

    handleAcceptAgreement = (agreementId) => {
        this.blockUi();
        this.companyAgreementService
            .acceptAgreement(agreementId)
            .then(() => this.companyAgreementService.getStatus())
            .then((status) => {
                // Zaktualizuj status w sessionStorage, żeby banner się odświeżył
                sessionStorage.setItem('company-agreement-status', JSON.stringify(status));
                // Wyślij custom event, żeby banner się zaktualizował (dla tej samej karty)
                window.dispatchEvent(new Event('company-agreement-status-updated'));
                this.setState({companyAgreementStatus: status}, () => this.unblockUi());
                this.showSuccessMessage('Zgoda została zaakceptowana.');
            })
            .catch((err) => {
                this.unblockUi();
                const msg =
                    (err && typeof err === 'string') ? err :
                    err?.message || err?.detail || err?.error || err?.errorMessage || 'Nie udało się zaakceptować zgody';
                this.showErrorMessage(msg);
            });
    };

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }

    getContainerListName() {
        return 'company-details';
    }

    breadCrumbItems() {
        return [{name: t('company.details'), url: ``}];
    }
    handleMarkerDrag(coordinates, markerIndex) {
        this.handleCoordinatesChange(coordinates);
    }

    handleCoordinatesChange(position) {
        this.setState((prevState) => ({
            element: {
                ...prevState.element,
                latitude: position.lat,
                longitude: position.lng,
            },
            circleCenter: [position.lat, position.lng],
        }));
    }

    isNotEmptyTransportTypes() {
        return this.state.transportTypes && this.state.transportTypes.length !== 0;
    }

    uploadHandler = (uploadedFile) => {
        if(uploadedFile != null){
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                newLogoUuid: uploadedFile.uuid,
            },
        }));
        }
    };

    uploadDarkHandler = (uploadedDarkFile) => {
        if(uploadedDarkFile != null){
        this.setState((prevState) => ({
            uploadedDarkFile,
            element: {
                ...prevState.element,
                newLogoDarkUuid: uploadedDarkFile.uuid,
            },
        }));
    }
    };

    handleOpenLocationImport = (e) => {
        e.preventDefault();
        this.locationImportInputRef?.current?.click();
    };

    handleLocationImportChange = (e) => {
        const file = e?.target?.files?.[0];
        if (!file) {
            return;
        }
        this.blockUi();
        this.companyLocationImportService
            .upload(file)
            .then((response) => {
                const importUuid = response?.uuid;
                if (importUuid) {
                    this.startLocationImportPolling(importUuid);
                }
                this.showSuccessMessage('Uruchomiono import lokalizacji w tle.');
                this.unblockUi();
            })
            .catch((err) => {
                this.showErrorMessage(err?.message || 'Wystąpił błąd podczas importowania lokalizacji');
                this.unblockUi();
            })
            .finally(() => {
                if (this.locationImportInputRef?.current) {
                    this.locationImportInputRef.current.value = null;
                }
            });
    };

    startLocationImportPolling = (importUuid) => {
        this.stopLocationImportPolling();
        this.locationImportPollingInterval = setInterval(() => {
            this.companyLocationImportService
                .getImportByUuid(importUuid)
                .then((res) => {
                    const item = res?.content?.[0];
                    if (!item) {
                        return;
                    }
                    const importId = item.id;
                    const imported = item.importedCount || 0;
                    const notImported = item.notImportedCount || 0;
                    const total = item.totalCount || 0;
                    const processed = imported + notImported;
                    const progress = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
                    const completed = total > 0 && processed >= total;
                    this.setState({
                        locationImportProgress: {imported, notImported, total, progress, completed},
                    });
                    if (completed) {
                        this.stopLocationImportPolling();
                        this.companyLocationImportService
                            .getErrorLogs(importId)
                            .then((errs) => {
                                const errors = errs?.content || [];
                                this.setState({locationImportErrors: errors}, () => {
                                    this.showSuccessMessage(`Import zakonczony. Poprawnie: ${imported}, bledy: ${notImported}`);
                                    this.setElement();
                                });
                            })
                            .catch(() => {
                                this.showSuccessMessage(`Import zakonczony. Poprawnie: ${imported}, bledy: ${notImported}`);
                                this.setElement();
                            });
                    }
                })
                .catch(() => {});
        }, 2000);
    };

    stopLocationImportPolling = () => {
        if (this.locationImportPollingInterval) {
            clearInterval(this.locationImportPollingInterval);
            this.locationImportPollingInterval = null;
        }
    };

    componentWillUnmount() {
        this.stopLocationImportPolling();
        if (super.componentWillUnmount) {
            super.componentWillUnmount();
        }
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        const validator = this.validator;
        for (let key in validator.fields) {
            if (validator.fields.hasOwnProperty(key)) {
                delete validator.fields[key];
            }
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    renderDetails() {
        const {locale} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='col-12'>
                        <TabView
                            activeIndex={this.state.tabIndex}
                            onTabChange={(e) => {
                                this.changeTab(e);
                            }}
                        >
                            <TabPanel header={t('my-company.info')}>
                                <div className='row mt-4 mb-4'>
                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                                        <InputTextComponent
                                            id={`${locale}-name`}
                                            name='name'
                                            label={t('my-company.name')}
                                            colClass='col-xl-4 col-lg-6 col-md-6 col-sm-12'
                                            value={this.state.element?.name}
                                            validator={this.validator}
                                            onChange={this.handleChange}
                                            viewMode={'VIEW'}
                                        />
                                    </div>
                                    <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                                        <ImageComponent
                                            style={{
                                                maxWidth: '80%',
                                                maxHeight: '400px',
                                                height: 'auto',
                                                width: 'auto'
                                              }}
                                            label={t('company.logo')}
                                            key='company-logo'
                                            srcUrl={`${this.service.getPath()}/logo/${
                                                this.state.element?.logoUuid
                                            }?token=${this.authService?.getToken()}`}
                                            alt='Logo'
                                            handleRemove={(e) => {
                                                this.setState((prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        logoUuid: null,
                                                    },
                                                }));
                                            }}
                                            notValidImageTypeErrorMessage={() => {
                                                this.showErrorMessage(t('image.notValidImageType'));
                                            }}
                                            validator={this.validator}
                                            errorMessage={this.showErrorMessage}
                                            imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                            fileSizeToTranslation={this.state.fileSizeToTranslation}
                                            attachment={this.state.element.logoUuid}
                                            setFile={this.uploadHandler}
                                            viewMode={this.props.viewMode}
                                        />
                                    </div>

                                    <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                                        <div
                                            style={{
                                                background: 'linear-gradient(135deg, #2b3440 0%, #3b4552 100%)',
                                                borderRadius: '12px',
                                                padding: '12px',
                                                color: '#fff',
                                            }}
                                        >
                                            <ImageComponent
                                                label={t('company.logo-dark')}
                                                labelStyle={{color: '#fff'}}
                                                key='company-logo-dark'
                                                srcUrl={`${this.service.getPath()}/logo/${
                                                    this.state.element?.logoDarkUuid
                                                }?token=${this.authService?.getToken()}`}
                                                alt='Logo-dark'
                                                handleRemove={(e) => {
                                                    this.setState((prevState) => ({
                                                        element: {
                                                            ...prevState.element,
                                                            logoDarkUuid: null,
                                                        },
                                                    }));
                                                }}
                                                notValidImageTypeErrorMessage={() => {
                                                    this.showErrorMessage(t('image.notValidImageType'));
                                                }}
                                                validator={this.validator}
                                                errorMessage={this.showErrorMessage}
                                                imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                                                fileSizeToTranslation={this.state.fileSizeToTranslation}
                                                attachment={this.state.element.logoDarkUuid}
                                                setFile={this.uploadDarkHandler}
                                                viewMode={this.props.viewMode}
                                            />
                                        </div>
                                    </div>
                                   
                                </div>
                            </TabPanel>
                            <TabPanel header={t('my-company.locations')} className='location-tab-panel'>
                                {!this.state?.companyLocationsLoading && (
                                    <>
                                        {this.props.viewMode !== 'VIEW' && (
                                            <div className='row mt-4 mb-2'>
                                                <div className='col-12 d-flex align-items-center'>
                                                    <button
                                                        type='button'
                                                        className='p-button p-component p-button-text-only dark'
                                                        onClick={this.handleOpenLocationImport}
                                                    >
                                                        <span className='p-button-text p-c'>Importuj lokalizacje z CSV</span>
                                                    </button>
                                                    <span className='ml-3 text-muted'>
                                                        Format: miejscowosc;kod pocztowy;ulica;numer domu
                                                    </span>
                                                    <input
                                                        ref={this.locationImportInputRef}
                                                        type='file'
                                                        accept='.csv,text/csv'
                                                        style={{display: 'none'}}
                                                        onChange={this.handleLocationImportChange}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {this.state.locationImportProgress && (
                                            <div className='row mb-3'>
                                                <div className='col-12'>
                                                    <ProgressBar value={this.state.locationImportProgress.progress} />
                                                    <small className='text-muted'>
                                                        Przetworzono {this.state.locationImportProgress.imported}/
                                                        {this.state.locationImportProgress.total}
                                                    </small>
                                                </div>
                                            </div>
                                        )}
                                        {this.state.locationImportProgress?.completed && this.state.locationImportErrors?.length > 0 && (
                                            <div className='row mb-3'>
                                                <div className='col-12'>
                                                    <div className='card' style={{border: '1px solid #E6E8EB'}}>
                                                        <div className='card-header'>Bledne rekordy ({this.state.locationImportErrors.length})</div>
                                                        <div className='card-body p-0'>
                                                            <div className='table-responsive'>
                                                                <table className='table table-sm mb-0'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Nr rekordu</th>
                                                                            <th>Adres</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.locationImportErrors.map((e) => (
                                                                            <tr key={`err-${e.id}`}>
                                                                                <td>{e.csvRecordNumber}</td>
                                                                                <td>{e.locationAddress}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <LocationsComponentV2
                                            showErrorMessage={this.showErrorMessage}
                                            showSuccessMessage={this.showSuccessMessage}
                                            viewMode={this.props.viewMode}
                                            locations={this.state?.element?.locations}
                                            onAddLocation={(location) => {
                                                const locations = this.state.element.locations;
                                                locations.push(location);
                                                this.setState((prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        locations,
                                                    },
                                                }));
                                            }}
                                            validator={this.validator}
                                            onUpdateLocation={(locations) => {
                                                this.setState((prevState) => ({
                                                    element: {
                                                        ...prevState.element,
                                                        locations,
                                                    },
                                                }));
                                            }}
                                        />
                                    </>
                                )}
                            </TabPanel>
                            <TabPanel header={t('my-company.settings')}>
                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4 mb-4'>
                                    {/* <Panel header='Ustawienia firmy'> */}
                                    {/* <InputCheckboxComponent
                                        id='sendMonthSummaryToUsers'
                                        name='sendMonthSummaryToUsers'
                                        labelOnRight
                                        label={t('my-company.send_summary')}
                                        value={this.state.element.sendMonthSummaryToUsers}
                                        validator={this.validator}
                                        validators='not_required'
                                        colClass='col-lg-12 col-md-12 col-sm-12'
                                        disabled={this.props.viewMode === 'VIEW'}
                                        onChange={this.handleChange}
                                        viewMode={'EDIT'}
                                    /> */}
                                    <InputCheckboxComponent
                                        id='twoFactorAuthentication'
                                        name='twoFactorAuthentication'
                                        labelOnRight
                                        label={t('my-company.two_factor_authentication')}
                                        value={this.state.element.twoFactorAuthentication}
                                        validator={this.validator}
                                        validators='not_required'
                                        colClass='col-lg-12 col-md-12 col-sm-12'
                                        disabled={this.props.viewMode === 'VIEW'}
                                        onChange={this.handleChange}
                                        viewMode={'EDIT'}
                                    />
                                    <InputDropdownComponent
                                        id='groupPointsAlgorithm'
                                        name='groupPointsAlgorithm'
                                        label={t('my-company.groupPointsAlgorithm.label')}
                                        optionLabel='label'
                                        dataKey='value'
                                        validator={this.validator}
                                        validators='required'
                                        value={this.state.element.groupPointsAlgorithm}
                                        options={getGroupPointsAlgorithmOptions(t)}
                                        colClass='col-lg-12 col-md-12 col-sm-12'
                                        disabled={this.props.viewMode === 'VIEW'}
                                        onChange={this.handleChange}
                                        viewMode={'EDIT'}
                                    />
                                    <div className='col-lg-12 col-md-12 col-sm-12 mt-2'>
                                        <Message
                                            severity='info'
                                            className='w-100'
                                            content={
                                                <div>
                                                    <div className='mb-2'>
                                                        <strong>{t('my-company.groupPointsAlgorithm.characteristicsTitle')}</strong>
                                                    </div>
                                                    <ul className='mb-3 ps-3'>
                                                        <li className='mb-1'>
                                                            <strong>{t('my-company.groupPointsAlgorithm.logarithmName')}:</strong>{' '}
                                                            {t('my-company.groupPointsAlgorithm.logarithmDescription')}
                                                        </li>
                                                        <li className='mb-1'>
                                                            <strong>{t('my-company.groupPointsAlgorithm.linearName')}:</strong>{' '}
                                                            {t('my-company.groupPointsAlgorithm.linearDescription')}
                                                        </li>
                                                        <li>
                                                            <strong>{t('my-company.groupPointsAlgorithm.averageName')}:</strong>{' '}
                                                            {t('my-company.groupPointsAlgorithm.averageDescription')}
                                                        </li>
                                                    </ul>
                                                    <div className='mb-2'>{t('my-company.groupPointsAlgorithm.examples.intro')}</div>
                                                    <div className='mb-1'>
                                                        <strong>{t('my-company.groupPointsAlgorithm.examples.scenario1Title')}</strong>
                                                    </div>
                                                    <ul className='mb-2 ps-3'>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario1Logarithm')}</li>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario1Linear')}</li>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario1Average')}</li>
                                                    </ul>
                                                    <div className='mb-1'>
                                                        <strong>{t('my-company.groupPointsAlgorithm.examples.scenario2Title')}</strong>
                                                    </div>
                                                    <ul className='mb-0 ps-3'>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario2Logarithm')}</li>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario2Linear')}</li>
                                                        <li>{t('my-company.groupPointsAlgorithm.examples.scenario2Average')}</li>
                                                    </ul>
                                                </div>
                                            }
                                        />
                                    </div>
                                    {/* </Panel> */}
                                </div>
                            </TabPanel>
                            <TabPanel header={'Zgody'}>
                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4 mb-4'>
                                    
                                    {this.renderAgreementsStatus()}
                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

CompanyContainer.defaultProps = {
    lazy: true,
    editUrl: '/company/edit',
    detailUrl: '/company/details',
};

CompanyContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(CompanyContainer));
